import type {
  PublicUser,
  Message,
  DMConversation,
  GroupChat,
  Server,
  Channel,
  ChannelCategory,
  ChannelMessage,
} from "@snowcord/shared";

export const CURRENT_USER: PublicUser = {
  id: "u1",
  username: "atlas",
  displayName: "Atlas",
  avatarUrl: null,
  publicKey: "pk_atlas_placeholder",
  isAdmin: false,
  createdAt: "2025-01-15T10:00:00Z",
};

export const USERS: PublicUser[] = [
  CURRENT_USER,
  {
    id: "u2",
    username: "nova",
    displayName: "Nova",
    avatarUrl: null,
    publicKey: "pk_nova_placeholder",
    isAdmin: false,
    createdAt: "2025-01-16T10:00:00Z",
  },
  {
    id: "u3",
    username: "kai",
    displayName: "Kai",
    avatarUrl: null,
    publicKey: "pk_kai_placeholder",
    isAdmin: false,
    createdAt: "2025-02-01T10:00:00Z",
  },
  {
    id: "u4",
    username: "luna",
    displayName: "Luna",
    avatarUrl: null,
    publicKey: "pk_luna_placeholder",
    isAdmin: false,
    createdAt: "2025-02-10T10:00:00Z",
  },
  {
    id: "u5",
    username: "sage",
    displayName: "Sage",
    avatarUrl: null,
    publicKey: "pk_sage_placeholder",
    isAdmin: true,
    createdAt: "2025-01-01T10:00:00Z",
  },
];

export const DM_MESSAGES: Record<string, Message[]> = {
  u2: [
    {
      id: "dm1",
      senderId: "u2",
      content: "hey, did you see the new deploy pipeline?",
      nonce: "n1",
      createdAt: "2025-04-22T14:10:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
    {
      id: "dm2",
      senderId: "u1",
      content: "yeah, the CI time dropped by 40%",
      nonce: "n2",
      createdAt: "2025-04-22T14:11:00Z",
      editedAt: null,
      isPinned: false,
      reactions: { "👍": ["u2"] },
    },
    {
      id: "dm3",
      senderId: "u2",
      content: "huge win. we should update the docs too",
      nonce: "n3",
      createdAt: "2025-04-22T14:12:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
    {
      id: "dm4",
      senderId: "u1",
      content: "on it. also pushed the new branch for the E2EE refactor",
      nonce: "n4",
      createdAt: "2025-04-22T14:15:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
    {
      id: "dm5",
      senderId: "u2",
      content: "nice. I'll review after lunch",
      nonce: "n5",
      createdAt: "2025-04-22T14:16:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
  ],
  u3: [
    {
      id: "dm6",
      senderId: "u3",
      content: "quick question about the socket reconnection logic",
      nonce: "n6",
      createdAt: "2025-04-22T12:30:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
    {
      id: "dm7",
      senderId: "u1",
      content: "sure, what's up?",
      nonce: "n7",
      createdAt: "2025-04-22T12:31:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
    {
      id: "dm8",
      senderId: "u3",
      content: "when the server restarts, does the client auto-rejoin all rooms?",
      nonce: "n8",
      createdAt: "2025-04-22T12:32:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
    {
      id: "dm9",
      senderId: "u1",
      content: "yes, on reconnect we emit a rejoin event with all active room IDs",
      nonce: "n9",
      createdAt: "2025-04-22T12:34:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
  ],
  u4: [
    {
      id: "dm10",
      senderId: "u4",
      content: "the new avatar upload flow looks clean",
      nonce: "n10",
      createdAt: "2025-04-22T09:00:00Z",
      editedAt: null,
      isPinned: false,
      reactions: { "❤️": ["u1", "u4"] },
    },
    {
      id: "dm11",
      senderId: "u1",
      content: "thanks! still need to add the crop tool",
      nonce: "n11",
      createdAt: "2025-04-22T09:05:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
  ],
};

export const DM_CONVERSATIONS: DMConversation[] = [
  {
    userId: "u2",
    user: USERS[1],
    lastMessage: DM_MESSAGES.u2[DM_MESSAGES.u2.length - 1],
    unreadCount: 2,
    lastReadMessageId: "dm3",
    isMuted: false,
  },
  {
    userId: "u3",
    user: USERS[2],
    lastMessage: DM_MESSAGES.u3[DM_MESSAGES.u3.length - 1],
    unreadCount: 0,
    lastReadMessageId: "dm9",
    isMuted: false,
  },
  {
    userId: "u4",
    user: USERS[3],
    lastMessage: DM_MESSAGES.u4[DM_MESSAGES.u4.length - 1],
    unreadCount: 1,
    lastReadMessageId: "dm10",
    isMuted: true,
  },
];

export const GROUP_CHATS: GroupChat[] = [
  {
    id: "g1",
    name: "Infra Team",
    avatarUrl: null,
    createdBy: "u1",
    createdAt: "2025-02-01T10:00:00Z",
    memberCount: 4,
    lastMessage: {
      id: "gm1",
      senderId: "u5",
      content: "deploy looks stable. no errors in the last 2 hours",
      nonce: "gn1",
      createdAt: "2025-04-22T16:00:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
    unreadCount: 5,
    lastReadMessageId: null,
    isMuted: false,
  },
  {
    id: "g2",
    name: "Design Review",
    avatarUrl: null,
    createdBy: "u3",
    createdAt: "2025-03-01T10:00:00Z",
    memberCount: 3,
    lastMessage: {
      id: "gm2",
      senderId: "u4",
      content: "updated the mockups in figma, check the components page",
      nonce: "gn2",
      createdAt: "2025-04-22T15:30:00Z",
      editedAt: null,
      isPinned: false,
      reactions: { "👀": ["u1", "u3"] },
    },
    unreadCount: 0,
    lastReadMessageId: "gm2",
    isMuted: false,
  },
];

export const SERVERS: Server[] = [
  {
    id: "s1",
    name: "Snowcord HQ",
    iconUrl: null,
    ownerId: "u5",
    inviteCode: "snow2025",
    isPublic: true,
    createdAt: "2025-01-01T10:00:00Z",
    memberCount: 12,
  },
  {
    id: "s2",
    name: "Open Source",
    iconUrl: null,
    ownerId: "u1",
    inviteCode: "oss2025",
    isPublic: true,
    createdAt: "2025-03-15T10:00:00Z",
    memberCount: 8,
  },
];

export const CHANNEL_CATEGORIES: ChannelCategory[] = [
  { id: "cat1", serverId: "s1", name: "General", position: 0 },
  { id: "cat2", serverId: "s1", name: "Engineering", position: 1 },
  { id: "cat3", serverId: "s2", name: "Discussion", position: 0 },
  { id: "cat4", serverId: "s2", name: "Projects", position: 1 },
];

export const CHANNELS: Channel[] = [
  {
    id: "ch1",
    serverId: "s1",
    name: "welcome",
    type: "text",
    categoryId: "cat1",
    position: 0,
    slowmodeSeconds: 0,
    topic: "Welcome to Snowcord HQ",
  },
  {
    id: "ch2",
    serverId: "s1",
    name: "general",
    type: "text",
    categoryId: "cat1",
    position: 1,
    slowmodeSeconds: 0,
    topic: "General discussion",
  },
  {
    id: "ch3",
    serverId: "s1",
    name: "dev",
    type: "text",
    categoryId: "cat2",
    position: 0,
    slowmodeSeconds: 5,
    topic: "Development discussion",
  },
  {
    id: "ch4",
    serverId: "s1",
    name: "standup",
    type: "voice",
    categoryId: "cat2",
    position: 1,
    slowmodeSeconds: 0,
    topic: null,
  },
  {
    id: "ch5",
    serverId: "s2",
    name: "introductions",
    type: "text",
    categoryId: "cat3",
    position: 0,
    slowmodeSeconds: 0,
    topic: "Say hello!",
  },
  {
    id: "ch6",
    serverId: "s2",
    name: "help",
    type: "text",
    categoryId: "cat3",
    position: 1,
    slowmodeSeconds: 10,
    topic: "Get help with open source projects",
  },
  {
    id: "ch7",
    serverId: "s2",
    name: "showcase",
    type: "text",
    categoryId: "cat4",
    position: 0,
    slowmodeSeconds: 0,
    topic: "Show off your work",
  },
  {
    id: "ch8",
    serverId: "s2",
    name: "pair-programming",
    type: "voice",
    categoryId: "cat4",
    position: 1,
    slowmodeSeconds: 0,
    topic: null,
  },
];

export const CHANNEL_MESSAGES: Record<string, ChannelMessage[]> = {
  ch2: [
    {
      id: "cm1",
      channelId: "ch2",
      authorId: "u5",
      author: USERS[4],
      content: "welcome to the new server layout everyone",
      createdAt: "2025-04-22T08:00:00Z",
      editedAt: null,
      isPinned: true,
      reactions: { "🎉": ["u1", "u2", "u3", "u4"] },
    },
    {
      id: "cm2",
      channelId: "ch2",
      authorId: "u2",
      author: USERS[1],
      content: "looks great! the new sidebar is much cleaner",
      createdAt: "2025-04-22T08:05:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
    {
      id: "cm3",
      channelId: "ch2",
      authorId: "u3",
      author: USERS[2],
      content: "agreed. the collapsible categories are a nice touch",
      createdAt: "2025-04-22T08:07:00Z",
      editedAt: null,
      isPinned: false,
      reactions: { "👍": ["u5"] },
    },
    {
      id: "cm4",
      channelId: "ch2",
      authorId: "u1",
      author: USERS[0],
      content: "thanks! we also added keyboard shortcuts. press Ctrl+/ to see them",
      createdAt: "2025-04-22T08:10:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
    {
      id: "cm5",
      channelId: "ch2",
      authorId: "u4",
      author: USERS[3],
      content: "the emoji picker is really smooth too",
      createdAt: "2025-04-22T08:12:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
    {
      id: "cm6",
      channelId: "ch2",
      authorId: "u4",
      author: USERS[3],
      content: "also love the message formatting. markdown support is great",
      createdAt: "2025-04-22T08:13:00Z",
      editedAt: null,
      isPinned: false,
      reactions: { "💯": ["u1", "u2"] },
    },
    {
      id: "cm7",
      channelId: "ch2",
      authorId: "u5",
      author: USERS[4],
      content: "next up: voice channels. stay tuned",
      createdAt: "2025-04-22T08:15:00Z",
      editedAt: null,
      isPinned: false,
      reactions: { "🔥": ["u1", "u2", "u3", "u4"] },
    },
  ],
  ch3: [
    {
      id: "cm8",
      channelId: "ch3",
      authorId: "u1",
      author: USERS[0],
      content: "pushed the E2EE refactor to feat/e2ee-v2. the key exchange is much cleaner now",
      createdAt: "2025-04-22T10:00:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
    {
      id: "cm9",
      channelId: "ch3",
      authorId: "u2",
      author: USERS[1],
      content: "looking at it now. the group key distribution looks solid",
      createdAt: "2025-04-22T10:15:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
    {
      id: "cm10",
      channelId: "ch3",
      authorId: "u1",
      author: USERS[0],
      content: "yeah, each member gets an individually encrypted copy of the group key. nacl.box for each recipient",
      createdAt: "2025-04-22T10:17:00Z",
      editedAt: null,
      isPinned: false,
      reactions: { "🧠": ["u2", "u5"] },
    },
    {
      id: "cm11",
      channelId: "ch3",
      authorId: "u5",
      author: USERS[4],
      content: "nice. make sure we have a key rotation mechanism for when members leave",
      createdAt: "2025-04-22T10:20:00Z",
      editedAt: null,
      isPinned: false,
      reactions: {},
    },
  ],
};

export const PRESENCES: Record<string, "online" | "idle" | "dnd" | "offline"> = {
  u1: "online",
  u2: "online",
  u3: "idle",
  u4: "dnd",
  u5: "online",
};

export function getUserById(id: string): PublicUser | undefined {
  return USERS.find((u) => u.id === id);
}

export function getChannelsForServer(serverId: string): Channel[] {
  return CHANNELS.filter((c) => c.serverId === serverId).sort(
    (a, b) => a.position - b.position,
  );
}

export function getCategoriesForServer(serverId: string): ChannelCategory[] {
  return CHANNEL_CATEGORIES.filter((c) => c.serverId === serverId).sort(
    (a, b) => a.position - b.position,
  );
}

export function getChannelsForCategory(categoryId: string): Channel[] {
  return CHANNELS.filter((c) => c.categoryId === categoryId).sort(
    (a, b) => a.position - b.position,
  );
}

export function getUncategorizedChannels(serverId: string): Channel[] {
  return CHANNELS.filter(
    (c) => c.serverId === serverId && c.categoryId === null,
  ).sort((a, b) => a.position - b.position);
}

export function formatTimestamp(iso: string): string {
  const date = new Date(iso);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  }
  if (diffDays === 1) {
    return "Yesterday";
  }
  if (diffDays < 7) {
    return date.toLocaleDateString("en-US", { weekday: "short" });
  }
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
}

export function getInitials(name: string): string {
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

const AVATAR_COLORS = [
  "#F87171",
  "#FB923C",
  "#FBBF24",
  "#34D399",
  "#5EEAD4",
  "#60A5FA",
  "#A78BFA",
  "#F472B6",
];

export function getAvatarColor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}
